import { wishlistApi } from '../admin/api/masterApi'
import { fetchProducts } from './productApi'

function minimalProduct(assetId, title) {
  return {
    product_id: assetId,
    service_id: assetId,
    product_name: title || `Product #${assetId}`,
    price: null,
    discount_price: null,
    product_images: [],
  }
}

/** Same API as admin Wishlist page: GET /wishlists?user_id= */
export async function fetchWishlistsByUser(userId) {
  const rows = await wishlistApi.list({ user_id: userId })
  return rows || []
}

/**
 * Same API as admin Wishlist page: POST /wishlists
 * Body: { user_id, asset_id }
 */
export async function createWishlistItem({ user_id, asset_id }) {
  const existingRows = await fetchWishlistsByUser(user_id)
  const existing = (existingRows || []).find(
    (row) => String(row.asset_id) === String(asset_id)
  )
  if (existing) return existing

  return wishlistApi.create(
    JSON.stringify({
      user_id: Number(user_id),
      asset_id: Number(asset_id),
    }),
    { json: true }
  )
}

/** Same API as admin Wishlist page: DELETE /wishlists/:wishlist_id */
export async function deleteWishlistItem(wishlistId) {
  await wishlistApi.remove(wishlistId)
}

export async function loadWishlistItemsForUser(userId) {
  const [rows, products] = await Promise.all([
    fetchWishlistsByUser(userId),
    fetchProducts().catch(() => []),
  ])
  const byId = new Map(
    (products || []).map((product) => [String(product.product_id), product])
  )

  return (rows || [])
    .map((row) => {
      const assetId = Number(row.asset_id)
      const product =
        byId.get(String(assetId)) ||
        minimalProduct(assetId, row.service_title)
      return {
        wishlistId: Number(row.wishlist_id),
        product,
      }
    })
    .filter((item) => Boolean(item.wishlistId))
}
